module.exports = __webpack_public_path__ + "img/f.fc95ffcf.jpg";